import { RouteProp, useRoute } from '@react-navigation/native';
import { LayoutContext, ScreenSize } from 'contexts/LayoutContext';
import { SxProp } from 'dripsy';
import * as DocumentPicker from 'expo-document-picker';
import _ from 'lodash';
import React, { useContext, useEffect } from 'react';
import { useCreateBillPayment } from '../../hooks/useCreateBillPayment.hook';
import { BillPaymentStackParamList, BillPaymentStackRoutes } from '../../payment.navigator';
import { BillPaymentInstructionMobileComponent } from './BillPaymentInstructionMobile.component';
import { BillPaymentInstructionWebComponent } from './BillPaymentInstructionWeb.component';
import { EmailSubmissionIntroductionComponent } from './EmailSubmissionIntroduction.component';

export interface BillPaymentInstructionProps {}
export const BillPaymentInstructionScreen: React.FC<BillPaymentInstructionProps> = () => {
  const layout = useContext(LayoutContext);
  const route = useRoute<RouteProp<BillPaymentStackParamList, BillPaymentStackRoutes.Instruction>>();
  const { paymentType } = route.params;

  const createBillPayment = useCreateBillPayment();
  const {
    general: { setPaymentType, setAlertMessage },
    instruction: {
      postUploadDocument,
      setDocumentName,
      setUrlDocument,
      setDocumentId,
      setStatusButtonQuote,
      isLoadingQuote,
      runPostQuote,
      setDocumentSelected,
      emailInstructionData,
      postCreateBillPayment,
      resetChooseNewDocument
    },
    postCreateBillPayment: { nextParamProp }
  } = createBillPayment;

  useEffect(() => {
    if (!!paymentType) setPaymentType(paymentType);
  }, [paymentType]);

  useEffect(() => {
    if (!isLoadingQuote && nextParamProp == undefined) {
      setStatusButtonQuote(false);
    }
  }, [isLoadingQuote, nextParamProp]);

  const documentSelected = async (document: DocumentPicker.DocumentResult) => {
    if (!!document && document.type === 'success' && !!document.file) {
      resetChooseNewDocument();
      setDocumentSelected(document);
      const documentName = document.file.name;
      try {
        postUploadDocument(
          {
            file: document.file
          },
          async (data) => {
            setDocumentName(documentName);
            postCreateBillPaymentDocument(documentName, data.data.url);
          },
          (error) => {
            const { data } = error.response || ({} as any);
            const errorMessage = data && _.isString(data.message) ? data.message : error.message;
            setAlertMessage(errorMessage);
          }
        );
      } catch (error: any) {
        console.log('ERR: ' + error.message);
      }
    }
  };

  const postCreateBillPaymentDocument = async (fileName: string, url: string) => {
    postCreateBillPayment(
      {
        attachments: [{ fileName, url }]
      },
      async (data) => {
        if (!!data.data.id && !!Object.values(data.data.details).at(0)) {
          setDocumentId(data.data.id);
          setUrlDocument(Object.values(data.data.details).at(0).documentUrl);
          runPostQuote();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const renderEmailComponent = (): JSX.Element => {
    if (!!emailInstructionData) {
      return (
        <EmailSubmissionIntroductionComponent
          sx={layout.screenSize === ScreenSize.Tablet || layout.isMobile ? sxStyles.emailLayout : undefined}
          emailInstruction={emailInstructionData}
        />
      );
    } else {
      return <></>;
    }
  };

  if (layout.screenSize === ScreenSize.Tablet || layout.isMobile) {
    return (
      <BillPaymentInstructionMobileComponent
        documentCallback={documentSelected}
        useCreateBillPayment={createBillPayment}
        emailComponent={renderEmailComponent()}
      />
    );
  }
  return (
    <BillPaymentInstructionWebComponent
      documentCallback={documentSelected}
      useCreateBillPayment={createBillPayment}
      emailComponent={renderEmailComponent()}
    />
  );
};

const sxStyles: Record<string, SxProp> = {
  emailLayout: {
    mb: '$10',
    mt: '$5'
  }
};
